export default "__VITE_ASSET__CYYM3uZR__"